import { baseEnvironment } from './baseEnvironment';

export const environment = {
    ...baseEnvironment,
    apiUrl: 'https://api.traceeye-ce.sato.co.jp/api',
    formatArchiveUrl: 'https://traceeye-ce.sato.co.jp/',
};
